import { VStack } from "native-base";
import React from "react";

import Carousel from "@/components/molecules/Carousel";
import ProductCard from "@/components/molecules/ProductCard";
import ProductCardLoading from "@/components/molecules/ProductCard/ProductCardLoading";

import { HorizontalProductListProps } from "./types";

const HorizontalProductListtWeb = ({
  data,
  isLoading,
  onSelect,
  onPressDecrease,
  onPressIncrease,
}: HorizontalProductListProps) => {
  return (
    <VStack>
      <Carousel
        data={data || []}
        itemLayout={200}
        showViewMoreButton={false}
        renderItem={({ item }) =>
          isLoading ? (
            <ProductCardLoading />
          ) : (
            <ProductCard
              item={item}
              onPressDecrease={() => onPressDecrease(item)}
              onPressIncrease={() => onPressIncrease(item)}
              onSelect={() => onSelect(item?.item?._id)}
            />
          )
        }
      />
    </VStack>
  );
};

export default HorizontalProductListtWeb;
